import regularPlanReducer from "./regularPlanReducer";

const regularPlanReducers = {
    regularPlan : regularPlanReducer
}

export default regularPlanReducers;